"use strict";

var _defineProperty = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _HtmlLayer = _interopRequireDefault(require("./HtmlLayer"));
var _MeasurableNodes = _interopRequireDefault(require("./MeasurableNodes"));
var _SvgLayer = _interopRequireDefault(require("./SvgLayer"));
var _types = require("./types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
// Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function createRefs(length) {
  var rv = [];
  for (var i = 0; i < length; i++) {
    rv.push( /*#__PURE__*/React.createRef());
  }
  return rv;
}
var MeasurableNodesLayer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MeasurableNodesLayer, _React$PureComponent);
  var _super = _createSuper(MeasurableNodesLayer);
  function MeasurableNodesLayer(props) {
    var _this;
    _classCallCheck(this, MeasurableNodesLayer);
    _this = _super.call(this, props);
    var graphState = props.graphState;
    var vertices = graphState.vertices;
    _this.state = {
      vertices: vertices,
      nodeRefs: createRefs(vertices.length)
    };
    return _this;
  }
  _createClass(MeasurableNodesLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.measureNodes();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.measureNodes();
    }
  }, {
    key: "measureNodes",
    value: function measureNodes() {
      var _this$props$graphStat = this.props.graphState,
        layoutPhase = _this$props$graphStat.layoutPhase,
        vertices = _this$props$graphStat.vertices;
      if (layoutPhase !== _types.ELayoutPhase.CalcSizes) {
        return;
      }
      var nodeRefs = this.state.nodeRefs;
      if (!nodeRefs) {
        return;
      }
      var _this$props = this.props,
        layerType = _this$props.layerType,
        measureNode = _this$props.measureNode,
        senderKey = _this$props.senderKey,
        setSizeVertices = _this$props.setSizeVertices;
      var current = null;
      var utils = measureNode && {
        layerType: layerType,
        getWrapper: function getWrapper() {
          if (current) {
            return current.getRef();
          }
          throw new Error('Invalid scenario');
        },
        getWrapperSize: function getWrapperSize() {
          if (current) {
            return current.measure();
          }
          throw new Error('Invalid scenario');
        }
      };
      var sizeVertices = [];
      for (var i = 0; i < nodeRefs.length; i++) {
        current = nodeRefs[i].current;
        var vertex = vertices[i];
        if (current) {
          sizeVertices.push(_objectSpread({
            vertex: vertex
          }, measureNode && utils ? measureNode(vertex, utils) : current.measure()));
        }
      }
      setSizeVertices(senderKey, sizeVertices);
    }
  }, {
    key: "render",
    value: function render() {
      var nodeRefs = this.state.nodeRefs;
      if (nodeRefs) {
        var _this$props2 = this.props,
          getClassName = _this$props2.getClassName,
          _this$props2$graphSta = _this$props2.graphState,
          layoutVertices = _this$props2$graphSta.layoutVertices,
          renderUtils = _this$props2$graphSta.renderUtils,
          vertices = _this$props2$graphSta.vertices,
          layerType = _this$props2.layerType,
          renderNode = _this$props2.renderNode,
          setOnNode = _this$props2.setOnNode;
        var LayerComponent = layerType === _types.ELayerType.Html ? _HtmlLayer.default : _SvgLayer.default;
        return /*#__PURE__*/React.createElement(LayerComponent, Object.assign({
          classNamePart: "MeasurableNodesLayer"
        }, this.props), /*#__PURE__*/React.createElement(_MeasurableNodes.default, {
          nodeRefs: nodeRefs,
          getClassName: getClassName,
          layerType: layerType,
          renderNode: renderNode,
          renderUtils: renderUtils,
          vertices: vertices,
          layoutVertices: layoutVertices,
          setOnNode: setOnNode
        }));
      }
      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var vertices = nextProps.graphState.vertices;
      var stVertices = prevState.vertices;
      if (vertices === stVertices) {
        return null;
      }
      return {
        vertices: vertices,
        nodeRefs: createRefs(vertices.length)
      };
    }
  }]);
  return MeasurableNodesLayer;
}(React.PureComponent);
exports.default = MeasurableNodesLayer;